import React from 'react'
import { Section } from '@/components/frontend/atoms/layout/Section'
import { Container } from '@/components/frontend/atoms/layout/Container'
import { ResponsiveGrid } from '@/components/frontend/atoms/layout/ResponsiveGrid'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { Inline } from '@/components/shared/atoms/layout/Inline'
import { SectionIntro } from '@/components/frontend/molecules/SectionIntro'
import { BlogPostCard } from '@/components/frontend/molecules/BlogPostCard'
import { ButtonLink } from '@/components/frontend/atoms/navigation/ButtonLink'
import { useTranslation } from '@/hooks/useTranslation'
import type { PublicPost } from '@/types/frontend'

interface BlogSectionProps {
  posts: PublicPost[]
}

export const BlogSection: React.FC<BlogSectionProps> = ({ posts }) => {
  const { t, lp } = useTranslation()

  if (posts.length === 0) return null

  return (
    <Section padding="lg" id="blog">
      <Container>
        <Stack gap="12">
          <Inline gap="6" justify="between" align="end" wrap>
            <SectionIntro label={t('blog_section.label')} title={t('blog_section.heading')} subtitle={t('blog_section.subheading')} />
            <ButtonLink href={lp('/blog')} variant="secondary" arrow>{t('blog_section.view_all')}</ButtonLink>
          </Inline>
          <ResponsiveGrid cols="3" gap="4">
            {posts.map((post) => <BlogPostCard key={post.id} post={post} />)}
          </ResponsiveGrid>
        </Stack>
      </Container>
    </Section>
  )
}
